<template style="background-color:transparent" ;>
  <div></div>
</template>
<script>
import Vue from 'vue';

export default Vue.extend({
  name: 'loading-cell-renderer'
});
</script>
